import {AppState} from '../store';
import { formatEther as ethersFormatEther } from 'ethers';
import {formatEther} from '../../utils/formatEther';

export const getExchangeStatusData = (state: AppState) =>
  state.exchangeStatus.data;

export const getExchangeStatusBySlug = (
  state: AppState,
  props: {slug: string},
) => {
  const aumentTokenBalance = state.exchangeStatus.data[
    props.slug
  ]?.aumentTokenBalance?.toString();
  const ethBalance = state.exchangeStatus.data[
    props.slug
  ]?.ethBalance?.toString();

    return {
    ...state.exchangeStatus.data[props.slug],
    aumentTokenBalance:
      aumentTokenBalance &&
      formatEther(ethersFormatEther(aumentTokenBalance), 3),
    ethBalance:
      ethBalance &&
      formatEther(ethersFormatEther(ethBalance), 3),
  };
};
